/* eslint-disable react-refresh/only-export-components */
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const skeletonVariants = cva('motion-safe:animate-pulse bg-chariot-stroke', {
  variants: {
    shape: {
      line: 'h-2.5 w-full shrink-0 rounded',
      block: 'size-full rounded',
      circle: 'aspect-square rounded-full',
    },
  },
  defaultVariants: {
    shape: 'line',
  },
});

export interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

/**
 * Canonical skeleton placeholder. Replaces the legacy `Loader` pulse-bar mode and
 * the bespoke per-section skeleton helpers. Defaults `data-testid="loader"` for
 * test compatibility.
 */
const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ shape, className, ...props }, ref) => (
    <div
      ref={ref}
      data-testid="loader"
      className={cn(skeletonVariants({ shape }), className)}
      {...props}
    />
  )
);
Skeleton.displayName = 'Skeleton';

export { Skeleton, skeletonVariants };
